// src/utils/storageUtils.js
// 专门处理跨域localStorage问题的工具函数

/**
 * 确保在正确域名下保存localStorage数据
 * @param {string} key 存储键
 * @param {string} value 存储值
 * @param {boolean} verify 是否验证保存结果
 */
export const setLocalStorageSecurely = (key, value, verify = true) => {
  try {
    localStorage.setItem(key, value);
    
    if (verify) {
      // 验证数据是否正确保存
      const saved = localStorage.getItem(key);
      if (saved !== value) {
        console.warn(`localStorage保存验证失败: ${key}`, {
          expected: value,
          actual: saved,
          domain: window.location.origin
        });
        
        // 重试一次
        setTimeout(() => {
          localStorage.setItem(key, value);
          console.log(`localStorage重试保存: ${key}`, window.location.origin);
        }, 50);
      }
    }
  } catch (error) {
    console.error(`localStorage保存失败: ${key}`, error);
  }
};

/**
 * 批量保存用户登录数据到localStorage
 * @param {Object} userData 用户数据
 * @param {Object} tokens 令牌数据
 */
export const saveUserDataSecurely = (userData, tokens = null) => {
  const uid = userData.uid || userData.email;
  
  console.log('开始安全保存用户数据:', {
    uid,
    hasTokens: !!tokens,
    domain: window.location.origin,
    timestamp: new Date().toISOString()
  });
  
  // 批量保存
  setLocalStorageSecurely('uid', uid);
  setLocalStorageSecurely('userInfo', JSON.stringify(userData));
  
  if (tokens) {
    if (tokens.access_token) {
      setLocalStorageSecurely('access_token', tokens.access_token);
    }
    if (tokens.refresh_token) {
      setLocalStorageSecurely('refresh_token', tokens.refresh_token);
    }
  }
  
  // 设置登录完成标记
  setLocalStorageSecurely('loginCompleted', Date.now().toString());
  
  // 最终验证和强制同步
  setTimeout(() => {
    const verification = {
      uid: localStorage.getItem('uid'),
      userInfo: localStorage.getItem('userInfo'),
      access_token: localStorage.getItem('access_token'),
      domain: window.location.origin,
      success: localStorage.getItem('uid') === uid
    };
    
    console.log('用户数据保存最终验证:', verification);
    
    if (!verification.success) {
      console.error('用户数据保存失败，尝试重新保存');
      // 最后一次重试
      localStorage.setItem('uid', uid);
      localStorage.setItem('userInfo', JSON.stringify(userData));
      if (tokens?.access_token) {
        localStorage.setItem('access_token', tokens.access_token);
      }
    }
    
    // 触发自定义事件通知其他组件
    window.dispatchEvent(new CustomEvent('userLoginCompleted', {
      detail: { userData, tokens }
    }));
    
  }, 200);
};

/**
 * 检查localStorage数据是否在正确域名下
 */
export const verifyStorageDomain = () => {
  const currentDomain = window.location.origin;
  const hasUserData = localStorage.getItem('userInfo');
  
  console.log('localStorage域名验证:', {
    domain: currentDomain,
    hasUserData: !!hasUserData,
    storageItems: {
      uid: localStorage.getItem('uid'),
      userInfo: hasUserData ? 'exists' : 'missing',
      access_token: localStorage.getItem('access_token') ? 'exists' : 'missing'
    }
  });
  
  return {
    domain: currentDomain,
    hasUserData: !!hasUserData
  };
};